import {
    FLUSH,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
    REHYDRATE,
    persistReducer,
    persistStore
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { combineReducers, configureStore } from '@reduxjs/toolkit';

import withSplitView from 'components/WithSplitView/state';

import useAccessToken from 'hooks/useAccessToken/state';
import useCurrentOrganization from 'hooks/useCurrentOrganization/state';
import useCurrentUser from 'hooks/useCurrentUser/state';
import useLogout from 'hooks/useLogout/state';
import useOAuth2 from 'hooks/useOAuth2/state';
import useOrganizations from 'hooks/useOrganizations/state';

import onboardingData from 'pages/OnboardingCurrentUserPage/hooks/useData/state';

export const rootReducer = combineReducers({
    onboardingData,
    useAccessToken,
    useCurrentOrganization,
    useCurrentUser,
    useLogout,
    useOAuth2,
    useOrganizations,
    withSplitView
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['useOAuth2', 'withSplitView']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        }),
    reducer: persistedReducer
});

export const persistor = persistStore(store);
